import { PacketAction, PacketFamily } from 'eolib';
import type { Client } from '@/client';
import { GameState } from '@/game-state';
import { PvpState } from '@/pvp-state';
import { capturingKey, keyAction } from '@/keybindings';

const stores=new WeakMap<Client,PvpState>();
const registered=new WeakSet<Client>();
export function pvpState(client:Client){let s=stores.get(client);if(!s){s=new PvpState();stores.set(client,s);}return s;}
export function resetPvp(client:Client){pvpState(client).reset();}
export function registerPvp(client:Client){
  const state=pvpState(client);
  if(!registered.has(client)){
    registered.add(client);
    let shiftTap: {code:string;at:number}|null=null;
    window.addEventListener('keydown',e=>{
      if(capturingKey(e)){shiftTap=null;state.clearKeys();return;}
      const target=e.target;
      if(client.state!==GameState.InGame||target instanceof HTMLElement&&(target.isContentEditable||target.closest('input,textarea,select'))){shiftTap=null;state.clearKeys();return;}
      if(!e.repeat && keyAction(e)==='pk' && !e.ctrlKey && !e.altKey && !e.metaKey){
        if(['ShiftLeft','ShiftRight'].includes(e.code))shiftTap={code:e.code,at:performance.now()};
        else {shiftTap=null;state.toggleMobile();e.preventDefault();}
      }
      else if(!['ShiftLeft','ShiftRight'].includes(e.code))shiftTap=null;
      state.key(e.code,true,e.repeat);
    },true);
    window.addEventListener('keyup',e=>{state.key(e.code,false);if(shiftTap?.code===e.code){if(client.state===GameState.InGame && !e.ctrlKey && performance.now()-shiftTap.at<300)state.toggleMobile();shiftTap=null;}},true);
    window.addEventListener('blur',()=>{shiftTap=null;state.suspend();});
    document.addEventListener('visibilitychange',()=>{if(document.hidden){shiftTap=null;state.suspend();}});
    client.subscribeStateChanged(s=>{if(s!==GameState.InGame)state.reset();});
  }
  client.bus.registerPacketHandler(57 as PacketFamily,PacketAction.Reply,reader=>{
    try{state.snapshot(JSON.parse(reader.getString()));}catch{/* Ignore malformed status; never enable forced combat from it. */}
  });
}
